import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as actionCreators from '../../actions/actionCreators';
import Layout from './Layout';

// Map State to Props
function mapStateToProps(state){
	return {
		apiData  : state.apiData,
		keyDeals : state.keyDeals,
		currentRegion : state.currentRegion,
		currentRegionLabel : state.currentRegionLabel,
		currentLocation : state.currentLocation,
		currentLocationLabel : state.currentLocationLabel,
		currentLocationIndex : state.currentLocationIndex,
		userValidated : state.userValidated		
	}
}

// Map Dispatch to props
function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators , dispatch)
}

// Connect Layout component
const Root = connect(mapStateToProps , mapDispatchToProps)(Layout);

export default Root;


// WEBPACK FOOTER //
// ./src/js/components/layout/Root.js